import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@izimi/auth';
import { showSuccessMessage } from '@izimi/components';
import { firestore } from '@izimi/core';
import { useThrottledCallback } from '@izimi/hooks';
import { RealtimeCacheSync as BaseRealtimeCacheSync, RealtimeDatabaseEventKeys, useModules } from '@izimi/modules';

export const RealtimeCacheSync = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const {
    user: { useCurrentUser },
  } = useModules();

  const throttledShowBoxDocumentCopiedSuccessMessage = useThrottledCallback({
    callback: () => showSuccessMessage({
      message: t('shared:communications.documents.notifications.copied'),
    }),
    waitTimeMs: 1000,
  });

  const { currentUser } = useCurrentUser(Boolean(isAuthenticated));

  const onEvent = useCallback((event: Record<string, string>) => {
    if (event[RealtimeDatabaseEventKeys.BOX_DOCUMENT_COPIED_TO_VAULT]) {
      throttledShowBoxDocumentCopiedSuccessMessage();
    }
  }, [throttledShowBoxDocumentCopiedSuccessMessage]);

  if (!currentUser) {
    return null;
  }

  return <BaseRealtimeCacheSync firestore={firestore} user={currentUser} onEvent={onEvent} />;
};
